module.exports = __webpack_public_path__ + "static/media/spinner.440a52ba.gif";